const KB = 1024;
const MB = KB * 1024;

// Formata em base binária (1 MB = 1.048.576 bytes) — a mesma base usada
// pelos limites de upload, para o tamanho exibido nunca contradizer o limite.
export function formatFileSize(bytes: number, locale?: string): string {
  if (bytes >= MB) {
    return `${(bytes / MB).toLocaleString(locale, {
      maximumFractionDigits: 1,
    })} MB`;
  }
  return `${(bytes / KB).toLocaleString(locale, {
    maximumFractionDigits: 0,
  })} KB`;
}
